import { apiPost } from '../../../services/apiClient';
import { buildApiUrl, API_ENDPOINTS } from '../../../config/apiEndpoints';
import { useEffect, useState } from 'react';
import { LocationParameter, SearchRequestPayload } from '../../../models/search';
import { Pagination as PaginationComponent, Stack } from '@mui/material';
import { FreightOffer, Route } from '../../../components/tables/searchTable/offerSearchTable';

const useOffer = () => {

  const [searchParams, setSearchParams] = useState<Route & { marketplace?: string, orderBy?: string, orderAscending?: boolean }>({
    startLocation: {} as LocationParameter,
    destinationLocation: {} as LocationParameter,
    until: '',
  });
  const [loading, setLoading] = useState(false);
  const [offers, setOffers] = useState<FreightOffer[]>([]);
  const [page, setPage] = useState<number>(1);

  const fetchOffers = async ({
    startLocation,
    destinationLocation,
    until,
    marketplace,
    orderBy,
    orderAscending
  }: Route & { until?: string, marketplace?: string, orderBy?: string, orderAscending?: boolean }) => {
    if (Object.keys(startLocation).length === 0 || Object.keys(destinationLocation).length === 0) return;
    setLoading(true);

    // store params to be used when page changes
    setSearchParams({
      startLocation,
      destinationLocation,
      until,
      marketplace,
      orderBy,
      orderAscending,
    });

    try {
      const payload = {
        searchParameters: {
          startLocation,
          destinationLocation: destinationLocation,
          exclusiveLeftLowerBoundDateTime: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
          inclusiveRightUpperBoundDateTime: new Date(until ? new Date(until).getTime() + 80 * 24 * 60 * 60 * 1000 : Date.now() + 80 * 24 * 60 * 60 * 1000).toISOString(),
        },
        offset: (page - 1) * 15,
        limit: 15,
        create: true,
        marketplace: marketplace || 'TimocomMarketplace',
        ...(orderBy ? { orderBy, orderAscending: !!orderAscending } : {}),
      };

      const response = await apiPost<SearchRequestPayload>(buildApiUrl(API_ENDPOINTS.vehicle.search), payload);
      const data = await response.json();

      if (data.result?.payload) {
        setOffers(data.result.payload);
      } else {
        setOffers([]);
      }

    } catch (err) {
      setOffers([]);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers(searchParams).catch(() => {});
  }, [page]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const Pagination = offers.length === 0 && page === 1 ? null : (
    <Stack spacing={2} alignItems="center" mt={2}>
      <PaginationComponent
        page={page}
        count={500}
        onChange={handlePageChange}
        siblingCount={1}
        boundaryCount={0}
        color="standard"
        shape="rounded"
      />
    </Stack>
  );

  return {
    offers,
    Pagination,
    loading,
    fetchOffers,
    setOffers
  };
};

export default useOffer;
